import { useIsBiggerThan } from './useResponsive';

export type DrawerType = 'permanent' | 'back';

export const useDrawerType = (): DrawerType => {
  const isPermanent = useIsBiggerThan('lg');

  return isPermanent ? 'permanent' : 'back';
};
